import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSelectChange } from "@angular/material/select";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CentreService } from "../../../../services/centre.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Observable, Subject } from "rxjs";
import { Centre } from "../../../../interfaces/Centres";
import { FullChild } from "../../../../interfaces/FullChild";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-treatment-duration',
  templateUrl: './treatment-duration.component.html',
  styleUrls: ['./treatment-duration.component.scss']
})
export class TreatmentDurationComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  selectedCentreCode: string = '';
  centres$: Observable<Centre[]>;
  // selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
  children$: Observable<FullChild[]> | undefined;
  mData: any[] = [];
  selectedChild: FullChild | undefined;
  displayedColumns: string[] = ['sr', 'childName', 'centreName', 'dateOfAdmission', 'dateOfDischarge', 'duration'];
  datasource = new MatTableDataSource();
  averageDuration: number = 0;
  averageFollowupDays: number = 0;
  // SelectedCentre :any;
  SelectedCentre: any = null; // Change from undefined to null

  childSearchText: string = '';
  allChildren: FullChild[] = [];
  filteredChildren: FullChild[] = [];


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private matDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private readonly centreService: CentreService,
    private readonly mFirestore: AngularFirestore,
  ) {
    this.centres$ = this.centreService.getAllCentres();
    this.datasource = new MatTableDataSource();
  }

  // clearAll() {
  //   this.SelectedCentre = '';
  //   this.selectedCentreCode = '';
  //   this.selectedChild = undefined;
  //   this.mData = [];
  //   this.datasource.data = [];
  //   this.averageDuration = 0;
  //   this.averageFollowupDays = 0;
  //   this.children$ = undefined; // Reset children$ when clearing
  // }

  clearAll() {
    // ✅ clear centre - use null instead of empty string
    this.SelectedCentre = null; // or undefined
    this.selectedCentreCode = '';

    // ✅ clear child
    this.selectedChild = undefined;
    this.children$ = undefined;
    this.allChildren = [];
    this.filteredChildren = [];
    this.childSearchText = '';

    // ✅ clear table & stats
    this.mData = [];
    this.datasource.data = [];
    this.averageDuration = 0;
    this.averageFollowupDays = 0;
  }



  ngOnInit(): void {}


  // onCentreSelect(SelectedCentre: Centre) {
  //   if (!SelectedCentre) return;
  //
  //   console.log("Selected Centre:", SelectedCentre);
  //
  //   this.selectedCentre = SelectedCentre;
  //
  //   // // 1️⃣ Set centre details in form
  //   // this.studentForm.patchValue({
  //   //   centreName: selectedCentre.centreName,
  //   //   centreCode: selectedCentre.centreCode
  //   // });
  // }


  // setSelectedCentreCode($event: MatSelectChange) {
  //   this.selectedCentreCode = $event.value;
  //   console.log(this.selectedCentreCode);
  //   this.selectedChild = undefined;
  //   this.children$ = this.mFirestore.collection<FullChild>("ALChild", ref => ref.where('centreCode', '==', this.selectedCentreCode))
  //     .valueChanges()
  //     .pipe(
  //       map(children => children.sort((a, b) => {
  //         const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
  //         const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();
  //         return nameA.localeCompare(nameB);
  //       }))
  //     );
  // }

  setSelectedCentreCode(SelectedCentre: Centre) {
    if (!SelectedCentre) return;

    console.log("Selected Centre:", SelectedCentre);

    // ✅ single source of truth
    this.SelectedCentre = SelectedCentre;
    this.selectedCentreCode = SelectedCentre.centreCode;

    // reset child
    this.selectedChild = undefined;
    this.childSearchText = '';

    this.children$ = this.mFirestore
      .collection<FullChild>('ALChild', ref =>
        ref.where('centreCode', '==', this.selectedCentreCode)
      )
      .valueChanges()
      .pipe(
        map(children =>
          children.sort((a, b) =>
            `${a.firstName} ${a.lastName}`.localeCompare(
              `${b.firstName} ${b.lastName}`
            )
          )
        )
      );

    this.children$.pipe(takeUntil(this._destroyed$)).subscribe(children => {
      this.allChildren = children;
      this.filteredChildren = children;
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }



  filterChildren() {
    const value = this.childSearchText.toLowerCase();

    this.filteredChildren = this.allChildren.filter(c =>
      `${c.firstName} ${c.lastName}`.toLowerCase().includes(value)
    );
  }



  setSelectedChild($event: MatSelectChange) {
    this.selectedChild = $event.value as FullChild;
    console.log(this.selectedChild);
  }

  search() {
    console.log(this.selectedChild);
    this.calculateStay(this.selectedChild!!);
  }

  private calculateStay(selectedChild: FullChild) {
    this.mData = [];
    const today = new Date();

    this.selectedChild?.admissionData.forEach((ad, index) => {
      let dischargeDate = today;
      if (index % 2 == 0) {
        if (selectedChild.admissionData[index + 1] != null && selectedChild.admissionData[index + 1].dateOfDischarge) {
          dischargeDate = selectedChild.admissionData[index + 1].dateOfDischarge?.toDate()!;
        }

        let obj = {
          childName: selectedChild.firstName + " " + selectedChild?.lastName,
          childCode: selectedChild.childCode,
          centreName: selectedChild.centreName,
          admissionDate: ad.dateOfAdmission?.toDate(),
          dischargeDate: dischargeDate,
          treatmentDuration: this.calculateDurationBetweenDatesInDays(ad.dateOfAdmission?.toDate()!!, dischargeDate)
        };
        this.mData.push(obj);
      }
    });

    this.datasource = new MatTableDataSource(this.mData);
    this.datasource.paginator = this.paginator;
    this.datasource.sort = this.sort;

    this.calculateAverageDuration();
    this.calculateAverageFollowupDays();
    console.log(this.mData);
  }

  private calculateDurationBetweenDatesInDays(admissionDate: Date, dischargeDate: Date): string {
    const timeDifference = dischargeDate.getTime() - admissionDate.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    return daysDifference.toString();
  }

  private calculateAverageDuration() {
    const totalDuration = this.mData.reduce((acc, row) => acc + +row.treatmentDuration, 0);
    this.averageDuration = this.mData.length ? totalDuration / this.mData.length : 0;
  }

  private calculateAverageFollowupDays() {
    let followupCount = 0;
    let totalFollowupDays = 0;

    for (let i = 1; i < this.mData.length; i += 2) {
      totalFollowupDays += +this.mData[i].treatmentDuration;
      followupCount++;
    }

    this.averageFollowupDays = followupCount ? totalFollowupDays / followupCount : 0;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  calculateTotalDuration(data: any[]): number {
    return data.reduce((acc, row) => acc + +row.treatmentDuration, 0);
  }

  Clear() {}
}
